import { keyframes } from 'styled-components';
import smoothscroll from 'smoothscroll-polyfill';
// kickoff polyfill for other browsers support for smooth window scrolling
if (typeof window !== 'undefined') {
    smoothscroll.polyfill();
}
export const getFadeTransition = (numFrom, numTo) => {
    return keyframes `from {
    opacity: ${numFrom};
  }

  to {
    opacity: ${numTo};
  }`;
};
export const getBounceTransition = () => {
    return keyframes `
      0%  { padding-bottom: 5px; }
      25%, 75% { padding-bottom: 10px; }
      40%, 75% { padding-bottom: 20px; }
      50%, 90% { padding-bottom: 15px; }
      100%  {padding-bottom: 10px;}
  `;
};
export const scrollTo = (xCoords, yCoords, behavior = 'auto') => {
    if (!!behavior && typeof window !== 'undefined') {
        // TODO: might need polyfill to make this work in IE
        window.scrollTo({
            top: yCoords,
            left: xCoords,
            behavior: behavior,
        });
    }
    else {
        window.scrollTo(xCoords, yCoords);
    }
};
